import {lazyInitialize, nonenumerable} from 'core-decorators';
import { action, observable, runInAction } from 'mobx';
import APIRequestState from './_util/api-request';

class GetNavigation extends APIRequestState {
  getRequest(locale) {
    return this.ctx.sdk.get(`/content/navigation/${locale}`);
  }
}

class NavigationState {
  @lazyInitialize @nonenumerable pullNavigation = new GetNavigation(this.ctx);

  @nonenumerable listeners = [];
  @observable header = {
    navigation: [],
    navigationLogin: [],
  };
  @observable footer = {
    navigations: [],
    socials: [],
  };

  @action('getNavigation - navigation state')
  async getNavigation(locale) {
    return new Promise((resolve, reject) => {
      this.pullNavigation.load(locale).then((response) => {
        runInAction(() => {
          this.header = response.header;
          this.footer = response.footer;
        });
        return resolve(response);
      }).catch((err) => {
        if (__DEV__) {
          console.error(err);
        }
        runInAction(() => {
          this.header = {
            navigation: [],
            navigationLogin: [],
          };
          this.footer = {
            navigations: [],
            socials: [],
          };
        });
        return reject(err);
      });
    });
  }

  constructor(ctx) {
    Object.defineProperty(this, 'ctx', {
      value: ctx,
      enumerable: false,
    });
  }

  dispose() {
    while (this.listeners.length) {
      this.listeners.pop()();
    }
  }
}

export default NavigationState;



// WEBPACK FOOTER //
// ./spa/state/navigation.jsx